import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsPageComponent } from './settings-page/settings-page.component';
import { SettingsRoutingModule } from './settings-routing.module';
import { MaterialModule } from '../common/material/material.module';
import { SettingsKontaktdatenPageComponent } from './settings-kontaktdaten-page/settings-kontaktdaten-page.component';
import { AppRoutingModule } from '../app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GlobalDirectivesModule } from '../common/form/validation/global-directives.module';
import { ServiceModule } from '../service/service.module';
import { SettingsKontaktdatenDetailComponent } from './settings-kontaktdaten-detail/settings-kontaktdaten-detail.component';
import { SettingsDienstleistungsartenPageComponent } from './settings-dienstleistungsarten-page/settings-dienstleistungsarten-page.component';
import { SettingsDienstleistungsartenDetailComponent } from './settings-dienstleistungsarten-detail/settings-dienstleistungsarten-detail.component';
import { SettingsDienstleistungsmodulePageComponent } from './settings-dienstleistungsmodule-page/settings-dienstleistungsmodule-page.component';
import { SettingsDienstleistungsmoduleDetailComponent } from './settings-dienstleistungsmodule-detail/settings-dienstleistungsmodule-detail.component';
import { SettingsErzeugnungsanlagenExportComponent } from './settings-erzeugnungsanlagen-export/settings-erzeugnungsanlagen-export.component';
import { SettingsResourceUserDetailComponent } from './settings-resource-user-detail/settings-resource-user-detail.component';
import { SettingsResourceUserPageComponent } from './settings-resource-user-page/settings-resource-user-page.component';
import { SettingsFeldBeschreibungPageComponent } from './settings-feldbeschreibung-page/settings-feldbeschreibung-page.component';
import { SettingsFeldBeschreibungDetailComponent } from './settings-feldbeschreibung-detail/settings-feldbeschreibung-detail.component';
import { SettingsBedienungsanleitungPageComponent } from './settings-bedienungsanleitung-page/settings-bedienungsanleitung-page.component';
import { SettingsNetzzuordnungImportPageComponent } from './settings-netzzuordnung-import-page/settings-netzzuordnung-import-page.component';
import { SettingsNetzzuordnungImportDetailComponent } from './settings-netzzuordnung-import-detail/settings-netzzuordnung-import-detail.component';
import { PipeModule } from '../common/pipe/pipe.module';

@NgModule({
    declarations: [
        SettingsKontaktdatenDetailComponent,
        SettingsPageComponent,
        SettingsKontaktdatenPageComponent,
        SettingsDienstleistungsartenPageComponent,
        SettingsDienstleistungsartenDetailComponent,
        SettingsDienstleistungsmodulePageComponent,
        SettingsDienstleistungsmoduleDetailComponent,
        SettingsErzeugnungsanlagenExportComponent,
        SettingsResourceUserDetailComponent,
        SettingsResourceUserPageComponent,
        SettingsFeldBeschreibungPageComponent,
        SettingsFeldBeschreibungDetailComponent,
        SettingsBedienungsanleitungPageComponent,
        SettingsNetzzuordnungImportPageComponent,
        SettingsNetzzuordnungImportDetailComponent,
    ],
    imports: [
        CommonModule,
        SettingsRoutingModule,
        MaterialModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        GlobalDirectivesModule,
        ServiceModule,
        PipeModule,
    ],
})
export class SettingsModule {
}
